import httpClient from '@/shared/http-eserv-client';

const getNewSearchRequest = (requestDate) => httpClient.get(`/applicationrequests?$top=1&$orderby=requestdate desc&$expand=searchRequestDetails&$filter=requestType eq 'Search' and (status eq 'In Progress') and requestDate ge ${requestDate}`);
const postSearchRequest = (data) => httpClient.post('/applicationrequests/', data);
const getSearchRequestById = (requestId) => httpClient.get(`/applicationrequests/${requestId}/?$expand=searchRequestDetails,applicationFeeDetails($orderby=sortOrderId)`);

export {
  getNewSearchRequest,
  postSearchRequest,
  getSearchRequestById,
};
